const customColorsDark = {
 black: '#FFFFFF',
 darkestGray: '#FFFFFF',
 darkGray: '#BDBDBD',
 gray: '#686868',
 lightGray: '#686868',
 lightestGray: '#32353A',
 white: '#181C23',
 blue: '#6080FF',
 darkBlue: '#4060E0',
 lightBlue: '#232934',
 green: '#DDFDE9',
 lightGreen: '#01C0AE',
 red: '#FFCBCB',
 lightRed: '#FE5F5F',
 lightestRed: '#FEEFEF',
 orange: '#F68D2B',
 lightOrange: '#F68D2B',
 yellow: '#F4E19D',
 lightYellow: '#FCF7E6',
 bg1: '#181C23',
 bg2: '#121418',
};

export default customColorsDark;
